import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/smalt-logo-login.svg'


const _hoisted_1 = { class: "min-h-screen bg-[#F1F0EE] flex flex-col items-center justify-center px-4 py-12" }
const _hoisted_2 = { class: "w-full max-w-md bg-white rounded-2xl shadow-sm p-8 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-500 text-sm"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "text-gray-400 text-xs mt-4"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "text-xl font-semibold text-gray-900 mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-red-500 text-xs mb-3"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 0,
  class: "mt-6 pt-6 border-t border-gray-100"
}
const _hoisted_13 = { class: "text-xs text-gray-400" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { class: "text-gray-500 text-sm" }

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

type State =
  | "loading"
  | "positive-redirect"
  | "negative-form"
  | "negative-done"
  | "error";


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicReviewView',
  setup(__props) {

const route = useRoute();
const token = route.params.token as string;
const sentiment = route.query.sentiment as string;
const preview = route.query.preview as string;

const api = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT + "/api/v1",
  headers: { "Content-Type": "application/json" },
});

const state = ref<State>("loading");
const partnerName = ref("");
const customerName = ref("");
const googleReviewUrl = ref<string | null>(null);
const partnerPhone = ref<string | null>(null);
const feedbackText = ref("");
const submitting = ref(false);
const errorMessage = ref("");

onMounted(async () => {
  if (preview) {
    partnerName.value = "Smalt Installations GmbH";
    customerName.value = "Max Mustermann";
    googleReviewUrl.value = "https://google.com";
    partnerPhone.value = "+49 30 12345678";
    state.value = preview as State;
    return;
  }

  try {
    const { data } = await api.get(`/reviews/respond/${token}`);
    partnerName.value = data.partner_name;
    customerName.value = data.customer_name;
    googleReviewUrl.value = data.google_review_url;
    partnerPhone.value = data.partner_phone ?? null;

    if (sentiment === "positive") {
      await api.post(`/reviews/respond/${token}`, { sentiment: "positive" });
      state.value = "positive-redirect";
      if (googleReviewUrl.value) {
        setTimeout(() => {
          window.location.href = googleReviewUrl.value!;
        }, 2000);
      }
    } else if (sentiment === "negative") {
      state.value = "negative-form";
    } else {
      state.value = "error";
      errorMessage.value = "Ungültiger Link.";
    }
  } catch {
    state.value = "error";
    errorMessage.value = "Dieser Link ist leider nicht mehr gültig.";
  }
});

async function submitNegativeFeedback() {
  if (preview) {
    state.value = "negative-done";
    return;
  }
  submitting.value = true;
  try {
    await api.post(`/reviews/respond/${token}`, {
      sentiment: "negative",
      feedback_text: feedbackText.value || null,
    });
    state.value = "negative-done";
  } catch {
    errorMessage.value = "Fehler beim Senden. Bitte versuchen Sie es erneut.";
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Smalt",
        class: "h-8 mx-auto mb-8"
      }, null, -1)),
      (state.value === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Einen Moment... "))
        : (state.value === 'positive-redirect')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-4xl mb-4" }, "🙌", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900 mb-2" }, "Vielen Dank!", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-500 text-sm mb-6" }, " Wir freuen uns über Ihr positives Feedback. Hinterlassen Sie uns gerne eine Bewertung auf Google. ", -1)),
              (googleReviewUrl.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: googleReviewUrl.value,
                    target: "_blank",
                    class: "inline-block w-full bg-gray-900 text-white rounded-xl py-3 text-sm font-medium hover:bg-gray-700 transition"
                  }, " Jetzt auf Google bewerten ", 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, " Kein Google-Bewertungslink hinterlegt. "))
            ]))
          : (state.value === 'negative-form')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-4xl mb-4" }, "😔", -1)),
                _createElementVNode("h1", _hoisted_8, " Das tut uns leid, " + _toDisplayString(customerName.value || "Kunde") + ". ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-gray-500 text-sm mb-6" }, " Was hätten wir besser machen können? Ihr Feedback hilft uns, uns zu verbessern. ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((feedbackText).value = $event)),
                  rows: "4",
                  placeholder: "Ihr Feedback (optional)...",
                  class: "w-full border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-800 resize-none focus:outline-none focus:ring-2 focus:ring-gray-300 mb-4"
                }, null, 512), [
                  [_vModelText, feedbackText.value]
                ]),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorMessage.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: submitNegativeFeedback,
                  disabled: submitting.value,
                  class: "w-full bg-gray-900 text-white rounded-xl py-3 text-sm font-medium hover:bg-gray-700 transition disabled:opacity-50"
                }, _toDisplayString(submitting.value ? "Wird gesendet..." : "Feedback absenden"), 9, _hoisted_10)
              ]))
            : (state.value === 'negative-done')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-6\"><svg class=\"w-8 h-8 text-green-500\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 13l4 4L19 7\"></path></svg></div><h1 class=\"text-xl font-semibold text-gray-900 mb-3\"> Vielen Dank für Ihr Feedback </h1><p class=\"text-gray-500 text-sm leading-relaxed\"> Wir haben Ihre Rückmeldung erhalten und werden uns schnellstmöglich darum kümmern. </p>", 3)),
                  (partnerPhone.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, [
                          _cache[6] || (_cache[6] = _createTextVNode(" Bei dringenden Anliegen erreichen Sie uns unter ", -1)),
                          _createElementVNode("a", {
                            href: `tel:${partnerPhone.value}`,
                            class: "font-medium text-gray-600 hover:underline"
                          }, _toDisplayString(partnerPhone.value), 9, _hoisted_14)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (state.value === 'error')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-4xl mb-4" }, "🔗", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900 mb-2" }, "Link ungültig", -1)),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(errorMessage.value), 1)
                  ]))
                : _createCommentVNode("", true)
    ])
  ]))
}
}

})